import { COUPON_SERVICE_APIS, CUSTOMER_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

AxiosCurlirize(axios, () => {});

export const useVaccinationSingleRecordAPI = () => {
  const [singleRecord, setSingleRecord] = useState<any>([]);

  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();

  const execute = useCallback(
    async (vaccination_id: any) => {
      try {
        dispatch(
          setLoading({
            key: "isvaccinationSingleDataLoading",
            status: true,
          }),
        );
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .post(`${CUSTOMER_APIS?.VACCINATION_SINGLE_GET?.baseURL}`, vaccination_id, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            dispatch(
              setLoading({
                key: "isvaccinationSingleDataLoading",
                status: false,
              }),
            );
            if (res.data.status) {
              setSingleRecord(res.data.data);
              //
            } else {
              setSingleRecord([]);
            }
          })
          .catch((e: AxiosError) => {
            dispatch(
              setLoading({
                key: "isvaccinationSingleDataLoading",
                status: false,
              }),
            );
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              setSingleRecord([]);
              //   toast.error("Error while fetching List details");
            }
            if (e.status === 400) {
              setSingleRecord([]);
              //   toast("Product records not found");
            }

            if (e.response.status === 500) {
              setSingleRecord([]);
              toast.error("Server error 500");
            }
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        setSingleRecord([]);
      }
    },
    [dispatch],
  );
  return { execute, singleRecord };
};
